<template>
    <div>
        <div class="signup-header row border-bottom-light row justify-content-sm-center">
            <div class="col-sm-6">
                <h5 class="color-1">2. Your company</h5>
                <h2>One more step.</h2>
            </div>
        </div>

        <div class="row justify-content-sm-center">
            <div class="col-sm-6">
                <form class="shaded" @submit.prevent.stop="processForm" novalidate>
                    <div class="form-group" :class="{ error: $v.form.companyName.$error }">
                        <label class="full">
                            Company name
                            <input v-model="form.companyName" type="text" placeholder="" @input="$v.form.companyName.$touch">
                        </label>

                        <div v-if="$v.form.companyName.$error" class="messages">
                            <span v-if="!$v.form.companyName.required">Company name is required.</span>
                            <span v-if="!$v.form.companyName.minLength">Your company name must have at least 3 characters.</span>
                        </div>
                    </div>

                    <div v-if="salesChannels" class="form-group">
                        <label class="full">Sales channel</label>

                        <vSelect
                            label="description"
                            v-model="selectedSalesChannel"
                            :options="salesChannels"
                            placeholder="Pick a sales channel ..."
                            :searchable="false"
                            @input="updateSalesChannel">
                        </vSelect>
                    </div>

                    <location-fields @locationFieldsChanged="updateLocationFields"></location-fields>

                    <div class="row">
                        <div class="col-md-6">
                            <router-link :to="{ name: 'auth.signup.agent.create' }">
                                <input type="button" class="btn tertiary widest full" value="Back">
                            </router-link>
                        </div>
                        <div class="col-md-6">
                            <input type="submit" class="btn blue widest full" :class="{'opacity-50':submittingRegistration}" value="Submit" :disabled="!$v.form.$dirty || $v.form.$error">
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import LocationFields from '../LocationFields'
    import { required, email, minLength } from 'vuelidate/lib/validators'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        data: function() {
            return {
                step: 3,
                form: {
                    companyName: '',
                    salesChannel: '',
                },
                selectedSalesChannel: null,
                submittingRegistration: false
            }
        },
        validations: {
            form: {
                companyName: {
                    required,
                    minLength: minLength(3)
                }
            }
        },
        created: function() {
            // Redirect if we landed here without having passed through the needed steps

            if (this.accountSetup.type !== 'agent') {
                this.resetAccountSetup('agent');
                this.$router.push({ name: 'auth.signup' });
            }
            else {
                this.form = this.accountSetup;
                this.eventHub.$emit('sidebar', 'create');
                this.eventHub.$emit('topLink', 'login');
            }
        },
        mounted: function() {
            // this.form.companyName = 'My company';
        },
        asyncComputed: {
            async salesChannels() {
                try {
                    let response = await axios.get('/api/settings/GetChannelSalesList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        this.form.salesChannel = response.data[0];
                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        computed: {
            ...mapGetters([
                'accountSetup',
            ]),
        },
        methods: {
            ...mapActions([
                'resetAccountSetup',
                'updateAccountSetup',
                'register'
            ]),
            processForm: function() {
                if(!this.submittingRegistration){
                    this.form.step = this.step + 1;

                    // Update account setup data

                    this.updateAccountSetup(this.form);

                    // Create an agent account via API
                    this.submittingRegistration = true
                    this.register(this.parseQueryString(this.accountSetup)).then(response => {
                        this.submittingRegistration = false

                    })

                    // Reset the setup object

                    this.resetAccountSetup('agent');
                } else {
                    this.$toasted.info('Already submitting your registration, please wait');
                }
            },
            uploadPhoto: function() {

            },
            updateSalesChannel: function() {
                this.form.salesChannel = this.selectedSalesChannel.id || null;
            },
            updateLocationFields: function(fields) {
                for (var key in fields) {
                    if (fields.hasOwnProperty(key)) {
                        this.form[key] = fields[key];
                    }
                }
            }
        },
        components: {
            vSelect: extendedVSelect,
            LocationFields
        }
    }
</script>



// WEBPACK FOOTER //
// Step3.vue?2d0f9cfc